import { css } from "@emotion/core";
import { color, fontSizes } from "../../../theme/Theme";

export const billsListStyles = css({
  background: color.white,
  boxShadow: ` 0 0 0.625rem ${color.boxShadow}`,

  "img:hover": {
    cursor: "pointer"
  },
  ".ant-table-tbody > tr > td:nth-of-type(4)::after": {
    content: '"/-"'
  },
  ".downloadable-link": {
    color: color.lightBlue
  },
  ".pending,.rejected,.approved,.paid": {
    width: "5.5rem",
    height: "1.25rem",
    borderRadius: "1.25rem",
    color: color.black,
    fontSize: fontSizes.label,
    margin: "0 auto"
  },
  ".pending": {
    backgroundColor: color.lightYellow
  },
  ".rejected": {
    backgroundColor: color.melon
  },
  ".approved,.paid": {
    backgroundColor: color.lightGreen
  }
});

export const billFilterStyles = css({
  width: "16rem",
  ".ant-select-selection": {
    fontSize: fontSizes.label
  }
});

export const radioButtonStyles = {
  border: `solid 0.0625rem ${color.lightGreen}`,
  backgroundColor: color.darkGreen,
  color: color.white,
  fontSize: fontSizes.label
};

export const tableScroll = { y: "53vh", x: "max-content" };
